import { typeUtils } from '@festina-life/core'
import { useFormikContext } from '@festina-life/ui/hooks'
import { useEffect } from 'react'

import type { ScenarioFormProps } from './LifeCommitmentSaveOrCreateScenarioModalManager'

const validateKey = typeUtils.createValidator<ScenarioFormProps>()

export const LifeCommitmentSaveOrCreateScenarioFormListener = () => {
  const { values, setFieldValue } = useFormikContext<ScenarioFormProps>()

  useEffect(() => {
    void setFieldValue(validateKey('variantIdOrTitle'), undefined)
  }, [values.scenarioIdOrTitle, setFieldValue])

  return null
}
